module.exports = __webpack_public_path__ + "img/zkalyx.2b90e147.png";